Mode: {{ formGroup.get("lnk_delivery")?.get("mode")?.value }}

<!-- FIXME mode is a string value -->
@if ( deliveryModes && (deliveryModes.length != 0) && ($safeNavigationMigration(formGroup.get("lnk_delivery")?.get("mode")?.value) !== undefined)) {
  <div class="mode" ><span [class]="getClassModeDelivery()">{{ message  }}</span></div>
}


